const formatInput = (el) => {
  if (!el) return;

  if (
    !(el instanceof HTMLInputElement) &&
    !(el instanceof HTMLTextAreaElement)
  ) {
    return;
  }

  if (
    el.tagName === "INPUT" &&
    [
      "file",
      "checkbox",
      "radio",
      "password",
      "email",
      "number",
      "date",
      "datetime-local",
      "time",
      "month",
      "week",
      "range",
      "color",
      "hidden",
    ].includes(el.type)
  ) {
    return;
  }

  if (!el.value) return;

  const configs = JSON.parse(localStorage.getItem("app_configs") || "[]");

  const config =
    configs.find(
      (item) =>
        item.management === "Input Formatting" &&
        item.key === "input_case_workflow",
    ) || {};

  // if (config) {
  //   const inputValueFormate = JSON.parse(config?.value)?.[0]?.value || 'none';
  //   if (inputValueFormate === 'none') {
  //     return;
  //   }
  //   if (inputValueFormate === 'lowercase') {
  //     el.value = el.value.toLowerCase();
  //   }
  //   if (inputValueFormate === 'uppercase') {
  //     el.value = el.value.toUpperCase();
  //   }
  //   if (inputValueFormate === 'capitalize') {
  //     el.value = el.value.replace(
  //       /\b\w/g,
  //       (char) => char.toUpperCase()
  //     );
  //   }
  // } else {
  //   if (el.classList?.contains("input-lowercase")) {
  //     el.value = el.value.toLowerCase();
  //   }

  //   if (el.classList?.contains("input-uppercase")) {
  //     el.value = el.value.toUpperCase();
  //   }

  //   if (el.classList?.contains("input-capitalize")) {
  //     el.value = el.value.replace(
  //       /\b\w/g,
  //       (char) => char.toUpperCase()
  //     );
  //   }
  // }

  if (config?.value) {
    let inputValueFormate = "none";

    try {
      const parsed = JSON.parse(config.value);
      inputValueFormate = parsed?.[0]?.value || "none";
    } catch {
      inputValueFormate = config.value;
    }

    if (inputValueFormate === "lowercase") {
      el.value = el.value.toLowerCase();
    }

    if (inputValueFormate === "uppercase") {
      el.value = el.value.toUpperCase();
    }

    if (inputValueFormate === "capitalize") {
      el.value = el.value.replace(/\b\w/g, (char) => char.toUpperCase());
    }
  } else {
    if (el.classList?.contains("input-lowercase")) {
      el.value = el.value.toLowerCase();
    }

    if (el.classList?.contains("input-uppercase")) {
      el.value = el.value.toUpperCase();
    }

    if (el.classList?.contains("input-capitalize")) {
      el.value = el.value.replace(/\b\w/g, (char) => char.toUpperCase());
    }
  }
};

const initGlobalInputFormatter = () => {
  const handler = (e) => formatInput(e.target);

  document.addEventListener("input", handler);

  return () => {
    document.removeEventListener("input", handler, true);
  };
};

export default initGlobalInputFormatter;
